export default [
  {
    path: '/production-task-list',
    name: 'production-task-list',
    component: resolve => require(['views/production-task/production-task-list'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/production-task-form/:isEdit/:id',
    name: 'production-task-form',
    props:true,
    component: resolve => require(['views/production-task/production-task-form'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/production-task-detail/:id',
    name: 'production-task-detail',
    props:true,
    component: resolve => require(['views/production-task/production-task-detail'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/task-lot-operate/:status',
    name: 'task-lot-operate',
    props:true,
    component: resolve => require(['views/production-task/task-lot-operate'], resolve),
    meta: { auth: true, view: 'pc' }
  }
]
